import { atomWithRefresh } from 'infrastructure/state/atomWithRefresh'
import { fetchDistrictSchools } from 'shared/api/list'
import { districtIdAtom } from './district.atoms'

const PER_PAGE = 1000

export const districtSchoolsAtomWithRefresh = atomWithRefresh(async (get) => {
  const districtId = get(districtIdAtom)
  if (!districtId) return []
  const result = await fetchDistrictSchools({
    perPage: PER_PAGE,
    currentPage: 1,
    filters: { districtSearch: districtId.toString() },
    sort: { field: 'id', order: 'asc' },
  })
  return result?.data ?? []
})
